import React, { Fragment } from 'react';
import styled from 'react-emotion';
import theme from '@jetshop/ui/utils/theme';
import ProductImage from '@jetshop/ui/ProductList/ProductImage';
import { default as ProductLinkComponent } from '@jetshop/ui/ProductLink';
import { Price } from '@jetshop/ui/Price';

import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';

const Item = styled('div')`
  display: flex;
  justify-content: center;
  align-self: stretch;
  overflow: hidden;
  align-self: stretch;
  width: 50%;
`;

export const ProductLink = styled(ProductLinkComponent)`
  background-color: ${theme('colors.white')};
  display: flex;
  align-self: stretch;
  flex-flow: column;
  width: 100%;
  text-decoration: none;
`;

export const StyledProductImage = styled(ProductImage)`
  /* padding-top: 100%; */
  width: 100%;
  /* border: 1px solid ${theme('colors.border')}; */
  box-shadow: inset 0 0 0 1px ${theme('colors.border')};
`;

export const ProductName = styled('div')`
  flex-grow: 1;
  align-self: stretch;
  line-height: 1.3rem;
  color: ${theme('colors.product.name')};
  font-size: 1.05rem;
  padding: 0.7rem 0 0;
  margin: 0.3rem 0 0;
  display: flex;
  justify-content: center;
  font-weight: bold;

  > span {
    text-align: center;
  }
`;

export const ProductSubName = styled('div')`
  flex-grow: 1;
  align-self: stretch;
  line-height: 0.9rem;
  color: ${theme('colors.product.subName')};
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin: 0.4rem 0;
  > span {
    text-align: center;
  }
`;

export const ProductPrice = styled(Price)`
  margin-top: 0.5rem;
  line-height: 1rem;
  text-align: center;
  color: ${theme('colors.product.price')};
  font-weight: bold;
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: baseline;
  ${theme('below.md')} {
    ${Price.Old}, ${Price.New} {
      display: block;
      /* width: 100%; */
    }
  }

  ${Price.Old}, ${Price.New} {
    display: inline;
    padding: 0 0.3rem;
  }

  ${Price.New} ~ ${Price.Old} {
    font-size: 0.8rem;
  }

  ${Price.New} {
    order: 1;
  }

  ${Price.New} {
    color: ${theme('colors.product.discountPrice')};
  }
`;

const ProductContainer = styled(Item)`
  margin-bottom: 20px;

  ${theme('above.lg')} {
    ${p => p.theme.calculateWidth(4, 3)}
  }

  ${theme('below.lg')} {
    ${p => p.theme.calculateWidth(2, 3)}
  }
`;

export const ImagePlaceholder = styled.div`
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 100%;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    padding-bottom: 100%;
    background: #f5f5f5;
  }
`;

const PlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3%;

  ${theme('above.lg')} {
    ${p => p.theme.calculateWidth(4, 3)}
  }

  ${theme('below.lg')} {
    ${p => p.theme.calculateWidth(2, 3)}
  }
`;

const StyledLoadingLine = styled(LoadingLine)`
  margin-bottom: 1rem;
`;

export const ProductPlaceholder = () => (
  <PlaceholderWrapper>
    <ImagePlaceholder />
    <StyledLoadingLine widthRem={6} randomizeWidthBy={2} heightPx={16} />
    <StyledLoadingLine widthRem={4} randomizeWidthBy={1} heightPx={12} />
  </PlaceholderWrapper>
);

const ProductItem = ({ product, hideSubName, productsPerRow }) => {
  if (!product) {
    return <Fragment />;
  }

  if (product.primaryRoute === null) {
    product.primaryRoute = {
      path: '#'
    };
  }

  return (
    <ProductContainer productsPerRow={productsPerRow}>
      <ProductLink data-testid="product" product={product}>
        {product.images[0] && (
          <StyledProductImage
            image={product.images[0]}
            aspect={'1:1|1:1'}
            cover={false}
          />
        )}
        <ProductName>
          <span>{product.name}</span>
        </ProductName>
        {!hideSubName && (
          <ProductSubName>
            <span>{product.subName}</span>
          </ProductSubName>
        )}
        <ProductPrice
          price={product.price}
          previousPrice={product.previousPrice}
        />
      </ProductLink>
    </ProductContainer>
  );
};

export default ProductItem;
